import { action } from 'mobx';
import { adminPartnerApi } from '@link/admin/services';
import { Ota } from '@link/admin/services/types';
import { AccountbaseStatus } from '@link/share/services/const';
import { BaseAgent } from '@link/share/stores';

export class Agent extends BaseAgent {
  @action
  getAllOtas() {
    adminPartnerApi
      .listOtas({ status: [AccountbaseStatus.On] })
      .then(response => {
        this.setAllOtas(response.otas || []);
        this.setAllOtasLoaded(true);
      });
  }

  @action
  getOtaOrgs(otaId: string) {
    if (otaId !== this.targetOtaId) {
      this.setOtaOrgs([]);
      this.targetOtaOrgsLoaded = false;
      return adminPartnerApi
        .listOtaOrgs({ otaId, status: [AccountbaseStatus.On] })
        .then(response => {
          this.setOtaOrgs(response.orgs || []);
          this.setTargetOtaOrgsLoaded(true);
        });
    }
  }

  @action
  addOrUpdateOta(ota: Ota) {
    return adminPartnerApi
      .addOrUpdateOta({
        body: { ota }
      })
      .then(res => {
        if (res.otaId) {
          this.getAllOtas();
        }
        return res;
      });
  }

  @action
  deleteOta(agentId: string) {
    return adminPartnerApi
      .deleteOta({
        body: {
          otaId: agentId
        }
      })
      .then(res => {
        if (res.success) {
          this.getAllOtas();
        }
        return res;
      });
  }
}

export default new Agent();
